import { Component, OnInit, OnDestroy, Input, AfterViewInit, ViewChild, ElementRef, EventEmitter, Output, HostListener, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { AlertService, MessageSeverity, DialogType } from '../../services/alert.service';
import { UserLogin } from '../../models/user-login.model';
import { ICD, MasterConfig, ResponseAPI, ErrorList, ICDStep3 } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { AuthService } from '../../services/auth.service';
import { ConfigurationService } from '../../services/configuration.service';
import { Utilities } from '../../services/utilities';
import Swal from 'sweetalert2';
import { elevenDigitPhoneNumberValidator, PhoneNumberMaskDirective, tenDigitPhoneNumberValidator } from '../../phone-number-mask.directive';

import { environment } from './../../../environments/environment';
import { AgentService, PreSubmitIssue } from '../../services/agent.service';
import { AiHintStateService } from '../../services/ai-hint-state.service';
import { taxIdValidator } from '../../models/taxIdValidator';

// Use the globally loaded jQuery (index.html scripts) so jQuery UI and select2
// are guaranteed to be attached — module-bundled jQuery is a separate instance.
declare const $: any;


// import custom validator to validate 
import { MustMatch } from '../../models/MustMatch';
import { dateNotLessThanTodayValidator } from '../../models/dateNotLessThanTodayValidator';
import { postalCodeValidator } from '../../models/postalCodeValidator';

@Component({
    selector: 'app-sf-icd-offc-camp',
    templateUrl: './sf-icd-offc-camp.component.html',
    styleUrls: ['./sf-icd-offc-camp.component.scss'],
    standalone: false
})

export class SfIcdOffcCampComponent implements OnInit, AfterViewInit {
  icd = new ICDStep3();
  data = {
    name: 'John',
    age: 30
  };
  isFileProcessing: boolean = false;
  userLogin = new UserLogin(); id: string; q: string;
  isLoading = false;
  isTestCampaign = false;
  isCheckboxesDisabled = false;
  formResetToggle = true;
  modalClosedCallback: () => void;
  loginStatusSubscription: any;
  selectedCountry: string;
  selected_WC_details :string
  icdForm: FormGroup;
  section1Form: FormGroup;
  section2Form: FormGroup;
  section3Form: FormGroup;
  section4Form: FormGroup;
  section5Form: FormGroup;
  section6Form: FormGroup;
  selectedCampaignsControl: FormControl;
  @Input()
  isModal = false;
  IsPref_Differ = false;
  isReopenCase = false;
  noMiddleName: boolean = true;  // "No Middle Name" checked by default (matches Step 1)
  secondaryOwner: string = '';   // Feature 10 — concatenated secondary owner name (read-only display)
  submitted = false;
  ddlUSStates = [];
  ddlBest_Delivery_Time = [];
  ddlCAProvinence = [];
  isdataavailable = false;
  Canada_campaignData = [];
  Canada_campaignData_DD = [];
  Canada_retailsData = [];
  displayValue: string = '';
  PO_namesData = [];
  NC_namesData = [];
  RC_namesData = [];

  ssnValue: string = '';
  isUS: boolean = true;
  isInsuranceRequired: string = 'true';
  US_campaignData = [];
  US_campaignData_DD = [];
  US_retailsData = [];
  icd_o = new ICD();
  @Output() dataEmitter = new EventEmitter<any>();
  @Input() inputData: any;
  selectedFiles: FileList;
  validFiles: File[] = [];
  fileData: { attachment_FileName: string, attachment_Base64: string, attachment_Type:string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' }[] = [];
  maxFilesAllowed: number = 15; // Maximum number of files allowed
  maxFileSize: number = 10 * 1024 * 1024; // 10 MB max file size (FR3)
  // Staged upload-on-select state, keyed by form control name.
  uploadState: { [controlName: string]: 'uploading' | 'uploaded' | 'error' } = {};
  uploadError: { [controlName: string]: string } = {};
  // Per-control selection counter so a slow FileReader from a superseded selection is ignored (FR2).
  private uploadSeq: { [controlName: string]: number } = {};

  // Pre-submit AI review state
  preSubmitIssues: PreSubmitIssue[] = [];
  preSubmitLoading = false;
  showPreSubmitReview = false;

  // Document verification state
  verificationState: { [controlName: string]: 'pending' | 'verifying' | 'pass' | 'fail' | 'warn' } = {};
  verificationIssues: { [controlName: string]: string[] } = {};
  private readonly VERIFIED_DOC_TYPES: { [controlName: string]: string } = {
    'Attach_US_W_9': 'W9',
    'Attach_US_Articles_of_Incorporation': 'ArticlesOfIncorporation',
    'Attach_US_Void_Check_Bank_Account': 'VoidCheck',
    'Attach_US_Certificate_of_Insurance': 'CertificateOfInsurance',
    'Attach_Canada_Articles_of_Incorporation': 'ArticlesOfIncorporation',
    'Attach_Canada_Bank_Statement_or_Direct_Deposit': 'BankStatement',
    'Attach_Canada_Certificate_of_Insurance': 'CertificateOfInsurance',
    'Attach_Workers_Compensation': 'WorkersCompensation',
    'Attach_Canada_Worker_Compensation_Coverage': 'WorkersCompensation',
    'Attach_US_SS4_EIN': 'EIN',
  };

  US_Retails_selectedItems: any[] = [];
  US_Retails_isSelectedItemsinvalid = false;
  Canada_Retails_selectedItems: any[] = [];
  Canada_Retails_isSelectedItemsinvalid = false;
  US_Campaigns_selectedItems: any[] = [];
  US_savedCampaignsString:string;
  US_Campaigns_isSelectedItemsinvalid = false;
  Canada_Campaigns_selectedItems: any[] = [];
  Canada_Campaigns_isSelectedItemsinvalid = false;

  selectedRetailers: string[] = [];

  isOTPValid = false;
  btnDisplay = true;
  public masterConfig: MasterConfig[] = [];

  datad = {
    name: '',
    age: 0
  };

  @Output() idEmitter = new EventEmitter<string>();
  //@ViewChild('dobInput') dobInput: ElementRef;
  @ViewChild('datepicker') datepicker: ElementRef;
  @ViewChild('selectEl') selectEl: ElementRef;

  select2Options = {
    placeholder: 'Select an option...',
    width: '100%'
  };

  selectedOption: string;
  isPayrollProviderOther: boolean = false;

  controlDisplayNames: { [key: string]: string } = {

    US_or_CA: 'Country',
    Full_Legal_Company_Name: 'Full Legal Company Name',
    Tax_ID: 'Tax ID',

    State_of_Incorporation: 'State Of Incorporation',
    Provinence_of_Incorporation: 'Province Of Incorporation',

    Date_of_Incorporation: 'Date Of Incorporation',

    SSN_SIN: 'SSN/SIN',

    Company_Address1: 'Company Address 1',
    Company_City: 'Company City',
    Company_Postal_Code: 'Company Postal Code',
    Company_Office_Phone: 'Company Office Phone',
    Company_Business_Email: 'Company Business Email',

    Company_Country: 'Company County',
    Company_State: 'Company State',
    Company_Province: 'Company Province',

    Owner_First_Name: 'Owner First Name',
    Owner_Last_Name: 'Owner Last Name',
    Owner_Middle_Name: 'Owner Middle Name',

    Owner_Preferred_First_Name: 'Preferred First Name',
    Owner_Preferred_Last_Name: 'Preferred Last Name',

    Is_Preferred_Differ: 'Preferred Name Different',

    Owner_Perc: 'Ownership Percentage',

    Owner_Address1: 'Owner Address 1',
    Owner_City: 'Owner City',

    Owner_State: 'Owner State',
    Owner_Province: 'Owner Province',
    Owner_Postal_Code: 'Owner Postal Code',

    Owner_Mobile_Phone: 'Owner Mobile Phone',
    Owner_Home_Phone: 'Owner Home Phone',
    Owner_Email: 'Owner Email',

    Payroll_Provider: 'Payroll Provider',
    Payroll_Provider_other: 'Other Payroll Provider',

    isInsuranceRequired: 'Insurance Required',

    Attach_US_Articles_of_Incorporation: 'US Articles Of Incorporation',
    Attach_US_W_9: 'US W9',
    Attach_US_SS4_EIN: 'EIN Document',
    Attach_US_Void_Check_Bank_Account: 'Void Check / Bank Account',

    Attach_US_Certificate_of_Insurance: 'US Certificate Of Insurance',

    Attach_Canada_Articles_of_Incorporation: 'Canada Articles Of Incorporation',

    Attach_Canada_Bank_Statement_or_Direct_Deposit:
      'Bank Statement / Direct Deposit',

    Attach_Canada_Certificate_of_Insurance:
      'Canada Certificate Of Insurance',

    Attach_Workers_Compensation:
      'Workers Compensation',

    Attach_Additional_Document_SC: 'Additional Document for Smart Circle',

    TestCampaignNotListed:
      'Campaign Name',

    State_UI_ID: 'State UI ID',

    Effective_Date: 'Effective Date',

    Comments: 'Comments',

    ICD_retrain: 'ICD Retrain',

    Keep_Payroll_Active: 'Keep Payroll Active',

    Last_Date_payroll: 'Last Date Payroll',
    Last_Date_Service: 'Last Date Service',

    HUB_Manager_Contact_Name: 'Hub Manager Contact Name',
    HUB_Manager_Contact_Number: 'Hub Manager Contact Number',
    HUB_Manager_Contact_Email: 'Hub Manager Contact Email',
    HUB_Manager_Contact: 'Hub Manager Contact',

    Sales_tax_perc: 'Sales Tax Percentage',
    Sales_tax_perc_N: 'New Sales Tax Percentage',

    New_Address: 'New Address',
    Company_Address2: 'Company Address 2',

    New_Address_N: 'New Address',
    Company_Address_N: 'Company Address',
    Company_Address2_N: 'Company Address 2',
    Company_City_N: 'Company City',
    Company_Postal_Code_N: 'Company Postal Code',

    Company_Country_N: 'New Company County',
    Company_State_N: 'Company State',
    Company_Province_N: 'Company Province',

    Company_Office_Phone_N: 'Company Office Phone',
    Owner_Mobile_Phone_N: 'Owner Mobile Phone',

    New_DBA_Name: 'New DBA Name',
    Remove_DBA_Name: 'Remove DBA Name',

    Owner_Email_N: 'New Owner Email',

    Attach_Incorporation: 'Incorporation Document',
    Attach_DBA_Doc: 'DBA Document',
    Attach_Renter_Insurance: 'Renter Insurance',

    Attach_Insurance_Application: 'Insurance Application',
    Additional_Insurance_Questionnaire: 'Additional Insurance Questionnaire',

    NY_and_HI_Disability_Form: 'NY and HI Disability Form',

    B_8822_Document: 'B-8822 Document',

    Attach_RAA: 'RAA Document',

    Attach_NC_Recommendation: 'NC Recommendation',

    Attach_Insurance_Cancellation_Form:
      'Insurance Cancellation Form',

    Attach_US_Insurance_Application:
      'US Insurance Application',

    Node_Form: 'Node Form',

    TestCampaignNotListed_R:
      'Campaign Name',

    Hub_New: 'New Hub Name',

    Male_Emp: 'Male Employees',
    FeMale_Emp: 'Female Employees',

    Disability_Form: 'Disability Form',

    Extra_Provincial_License:
      'Extra Provincial License',

    Workers_Compensation:
      'Workers Compensation',
    Owner_Address2: 'Owner Address 2',

    Owner_Country: 'Owner Country',

    SSN_SIN_C: 'Confirm SSN/SIN',

    Tax_ID_C: 'Confirm Tax ID',

    Company_Address: 'Company Address',

    Owner_Consent: 'Owner Consent',

    Owner_Demographics: 'Owner Demographics',
  };

  fieldMaxLengths: any = {
    // EXISTING
    Full_Legal_Company_Name: 255,
    Tax_ID: 25,
    Company_Address1: 150,
    Company_Address2: 150,
    Company_City: 150,
    Company_Postal_Code: 10,
    Company_Office_Phone: 40,
    Company_Business_Email: 80,
    Company_Country: 100,
    Owner_First_Name: 250,
    Owner_Middle_Name: 255,
    Owner_Last_Name: 250,
    Owner_Preferred_First_Name: 255,
    Owner_Preferred_Last_Name: 255,
    Owner_Address1: 200,
    Owner_Address2: 200,
    Owner_City: 200,
    Owner_Postal_Code: 15,
    Owner_Mobile_Phone: 40,
    Owner_Home_Phone: 40,
    Owner_Email: 80,
    HUB_Manager_Contact: 255,
    Payroll_Provider_other: 255,
    Delivery_Contact_Name: 255,
    Alternate_Contact_Name: 255,
    Hours_of_Operation: 255,
    Special_Delivery_Requirements: 255,
    Company_Website: 255,
    TestCampaignNotListed: 255,
    State_UI_ID: 255,
    Sales_tax_perc_N: 10,
    Company_Address_N: 150,
    Company_Address2_N: 150,
    Company_City_N: 150,
    Company_Postal_Code_N: 10,
    Company_Country_N: 100,
    Company_Office_Phone_N: 40,
    Owner_Mobile_Phone_N: 40,
    New_DBA_Name: 255,
    Remove_DBA_Name: 255,
    New_DBA_Name0: 255,
    New_DBA_Name1: 255,
    New_DBA_Name2: 255,
    New_DBA_Name3: 255,
    New_DBA_Name4: 255,
    New_DBA_Name5: 255,
    New_DBA_Name6: 255,
    New_DBA_Name7: 255,
    New_DBA_Name8: 255,
    New_DBA_Name9: 255,
    Comments: 4000,
    Male_Emp: 10,
    FeMale_Emp: 10,
    // MISSING FIELDS FROM LATEST FORM
    Owner_Perc: 3,
    Promoting_Owner: 150,
    Promoting_Owner_Company: 255,
    Regional_Consultant: 200,
    Regional_Consultant_Company: 200,
    National_Consultant: 200,
    National_Consultant_Company: 200
  };
  constructor( private renderer: Renderer2, private el: ElementRef,private route: ActivatedRoute, private elRef: ElementRef, private fb: FormBuilder, private router: Router, private alertService: AlertService, private authService: AuthService, private configurations: ConfigurationService, private sfDataService: SfDataService, private agentService: AgentService, private hintStateService: AiHintStateService) { }

  @Output() activateTab = new EventEmitter<number>();

  ngOnInit(): void {


    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Attempting login...');
    //this.emitActivateTab(3);
    $('.detailchild').removeClass('active');
    $('.detailmain').removeClass('active');
    $('#custom-tabs-four-more-tab').removeClass('active');
    $('#custom-tabs-four-more-tab').parent().removeClass('active');
    $('#custom-tabs-four-profile-tab').addClass('active');
    $('#custom-tabs-four-profile-tab').parent().addClass('active');

    this.id = this.route.snapshot.paramMap.get('id');
    
    this.q = this.route.snapshot.paramMap.get('query');
    if (this.q != null) {
     
      this.ShowOTPpopup("Enter Access Code to continue");
      $('#custom-tabs-four-home-tab').parent().addClass('hide');
      $('#custom-tabs-four-messages-tab').parent().addClass('hide');
      $('#custom-tabs-four-more-tab').parent().addClass('hide');
    }
    
    this.datad = this.inputData;
    this.CreateForm();
    
    this.BindDropdowns();

    if (this.id != null) {
      if (this.q != null && !this.isOTPValid) {

      }
      else {
        this.idEmitter.emit(this.id);
        this.BindData(this.id);
        
      }
      
    }

  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event: Event): void {
    event.preventDefault();
  }
  ShowOTPpopup(str:string) {
    Swal.fire({
      title: 'OTP!',
      text: str,
      icon: 'warning',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,
      input: 'number',
      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (!val) {
          Swal.showValidationMessage("OTP is required");
        } else {
          try {

            // Create a new instance of the ICD class
            let responseAPI = new ResponseAPI();
            this.sfDataService.getOTP(this.id, val, this.q)
              .subscribe(
                data => {

                  //responseAPI = data;
                  // Assign the received data to the responseAPI object
                  responseAPI = data;
                  if (responseAPI.isSuccess) {
                    this.isOTPValid = responseAPI.isSuccess;
                    this.idEmitter.emit(this.id);
                    this.BindData(this.id);
                  }
                  else {
                    // API call failed, reject the Promise to prevent closing the popup
                    this.ShowOTPpopup("Wrong Access Code, Enter Access Code to continue");
                  }

                },
                error => {

                  this.alertService.stopLoadingMessage();

                  if (Utilities.checkNoNetwork(error)) {
                    this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
                    this.offerAlternateHost();
                  } else {
                    const errorMessage = Utilities.getHttpResponseMessage(error);

                    if (errorMessage) {
                      this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
                    } else {
                      this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
                    }
                  }

                  setTimeout(() => {
                    this.isLoading = false;
                  }, 500);
                });

            // await this.apiService.postData(val);
            // API call succeeded, resolve the Promise
          } catch (error) {
            // API call failed, reject the Promise to prevent closing the popup
            return Promise.reject(error);
          }
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Handle success case when the API call is successful
      } else if (result.isDenied) {
        // Handle the case when the user cancels the dialog
      } else if (result.isDismissed) {
        // Handle the case when the dialog is closed without confirmation
      }
    });
  }

  CreateForm() {
    this.icdForm = this.fb.group({
      US_or_CA: ['', Validators.required],
      Full_Legal_Company_Name: [{ value: '', disabled: true }],
      Tax_ID: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Tax_ID), this.noHtmlTagsValidator.bind(this)]],
      State_of_Incorporation: ['', Validators.required],
      Provinence_of_Incorporation: ['', Validators.required],
     // Years_in_Business: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      //Date_of_Incorporation: ['', [Validators.required, Validators.pattern(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)]],
      Date_of_Incorporation: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],
      SSN_SIN: ['', [Validators.required, Validators.pattern(this.isUS ? /^\d{9}$/ : /^\d{9}$/)]],
      Company_Address1: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Address1), this.noHtmlTagsValidator.bind(this)]],
      Company_Address2: ['', [Validators.maxLength(this.fieldMaxLengths.Company_Address2), this.noHtmlTagsValidator.bind(this)]],
      Company_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_City), this.noHtmlTagsValidator.bind(this)]],
      Company_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Postal_Code), postalCodeValidator()]],
      Company_Office_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Office_Phone), tenDigitPhoneNumberValidator()]],
      Company_Business_Email: ['', [Validators.required, Validators.email, Validators.maxLength(this.fieldMaxLengths.Company_Business_Email), this.noHtmlTagsValidator.bind(this)]],
      Company_Country: ['', Validators.required],
      Company_State: ['', Validators.required],
      Company_Province: ['', Validators.required],
      selectedCampaigns : this.selectedCampaignsControl,
      Owner_First_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Middle_Name: [{ value: '', disabled: true }, [Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Last_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_First_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Preferred_Last_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Preferred_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      Is_Preferred_Differ: ['', Validators.required],
      Owner_Perc: ['', [Validators.required, Validators.min(1), Validators.max(100)]],
      Owner_Address1: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Address1), this.noHtmlTagsValidator.bind(this)]],
      Owner_Address2: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Address2), this.noHtmlTagsValidator.bind(this)]],
      Owner_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_City), this.noHtmlTagsValidator.bind(this)]],
      Owner_Country: [''],
      Owner_State: ['', Validators.required],
      Owner_Province: ['', Validators.required],
      Owner_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Postal_Code), postalCodeValidator()]],
      isInsuranceRequired: ['', Validators.required],


      Owner_Mobile_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Mobile_Phone), elevenDigitPhoneNumberValidator()]],
      Owner_Home_Phone: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Home_Phone), tenDigitPhoneNumberValidator()]],
      Owner_Email: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Email) ,this.noHtmlTagsValidator.bind(this)]],


      HUB_Manager_Contact_Name: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Number: [{ value: '', disabled: true }],
      HUB_Manager_Contact_Email: [{ value: '', disabled: true }],
      HUB_Manager_Contact: ['', [Validators.maxLength(this.fieldMaxLengths.HUB_Manager_Contact), this.noHtmlTagsValidator.bind(this)]],

      Promoting_Owner: [{ value: '', disabled: true }],
      Promoting_Owner_Company: [{ value: '', disabled: true }],
      Regional_Consultant: [{ value: '', disabled: true }],
      Regional_Consultant_Company: [{ value: '', disabled: true }],
      National_Consultant: [{ value: '', disabled: true }],
      National_Consultant_Company: [{ value: '', disabled: true }],

      Payroll_Provider: [''],
      Payroll_Provider_other: ['', [Validators.maxLength(this.fieldMaxLengths.Payroll_Provider_other), this.noHtmlTagsValidator.bind(this)]],

      Male_Emp: ['', [Validators.maxLength(this.fieldMaxLengths.Male_Emp)]],
      FeMale_Emp: ['', [Validators.maxLength(this.fieldMaxLengths.FeMale_Emp)]],
      Disability_Form: [''],

      Loading_Dock: [''],
      Fork_Lift: [''],
      Straight_Truck_Required: [''],
      Appointment_Required: [''],
      Lift_Gate_Required: [''],

      Delivery_Contact_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Delivery_Contact_Name), this.noHtmlTagsValidator.bind(this)]],
      Alternate_Contact_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Alternate_Contact_Name), this.noHtmlTagsValidator.bind(this)]],
      Hours_of_Operation: ['', [Validators.maxLength(this.fieldMaxLengths.Hours_of_Operation), this.noHtmlTagsValidator.bind(this)]],
      Best_Delivery_Time: [''],
      Special_Delivery_Requirements: ['', [Validators.maxLength(this.fieldMaxLengths.Special_Delivery_Requirements), this.noHtmlTagsValidator.bind(this)]],
      Company_Website: ['', [Validators.maxLength(this.fieldMaxLengths.Company_Website), this.noHtmlTagsValidator.bind(this)]],

      //items: ['', Validators.required],


      //Attach_US_Articles_of_Incorporation: ['', [Validators.required]],
      Attach_US_Articles_of_Incorporation: ['', [Validators.required]],
      Attach_US_W_9: ['', [Validators.required]],
      Attach_US_Node_Form: [''],
      Attach_US_SS4_EIN: ['', [Validators.required]],
      Attach_US_Void_Check_Bank_Account: ['', [Validators.required]],
      //Attach_US_Additional_Insurance: [''],
      //Attach_US_Form_8821: [''],
      //Attach_US_Homeowner_Insurance: [''],
      //Attach_US_ADP_Payroll: [''],
      Attach_US_Certificate_of_Insurance: ['', []],
      //Attach_US_Payroll_Setup: [''],
      
      Attach_Canada_Articles_of_Incorporation: ['', [Validators.required]],
      Attach_Canada_Bank_Statement_or_Direct_Deposit: ['', [Validators.required]],
      Attach_Canada_Worker_Compensation_Coverage: [''],
      //Attach_Canada_Bank_Account_statement: ['', [Validators.required]],
      //Attach_Canada_Worker_Compensation_Coverage: ['', [Validators.required]],
      //Attach_Canada_Insurance_Application: [''],
      //Attach_Canada_Additional_Insurance_Questionnaire: ['', [Validators.required]],
      //Attach_Canada_Homeowner_Insurance: [''],
      //Attach_Canada_ADP_Payroll: ['', [Validators.required]],
      //Attach_Canada_Out_of_Province_Qualification: [''],
      //Attach_Canada_Waddell_Privacy: [''],
      Attach_Canada_Certificate_of_Insurance: [''],


      Attach_Workers_Compensation: [''],
      // Always visible, always optional — uploaded to the Case in Salesforce if populated.
      Attach_Additional_Document_SC: [''],
      TestCampaignNotListed: ['', [Validators.maxLength(this.fieldMaxLengths.TestCampaignNotListed), this.noHtmlTagsValidator.bind(this)]]


    });
    
    this.section1Form = this.fb.group({
      US_or_CA: ['', Validators.required],
      Full_Legal_Company_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Full_Legal_Company_Name), this.noHtmlTagsValidator.bind(this)]],
      Tax_ID: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Tax_ID), this.noHtmlTagsValidator.bind(this)]],
      State_of_Incorporation: ['', Validators.required],
      Provinence_of_Incorporation: ['', Validators.required],
      //Years_in_Business: ['', [Validators.required, Validators.pattern('^[0-9]+$')]],
      //Date_of_Incorporation: ['', [Validators.required, Validators.pattern(/^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/)]]
      Date_of_Incorporation: ['', [Validators.required, Validators.pattern(/^(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])\-\d{4}$/)]],

    });
    this.section2Form = this.fb.group({
      Company_Address1: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Address1), this.noHtmlTagsValidator.bind(this)]],
      Company_Address2: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Address2), this.noHtmlTagsValidator.bind(this)]],
      Company_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_City), this.noHtmlTagsValidator.bind(this)]],
      Company_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Postal_Code), postalCodeValidator(() => this.section1Form.get('US_or_CA')?.value)]],
      Company_Office_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Company_Office_Phone), tenDigitPhoneNumberValidator()]],
      Company_Business_Email: ['', [Validators.required, Validators.email, Validators.maxLength(this.fieldMaxLengths.Company_Business_Email), this.noHtmlTagsValidator.bind(this)]],
      Company_Country: ['', Validators.required],
      Company_State: ['', Validators.required],
      Company_Province: ['', Validators.required]
    });

    this.section3Form = this.fb.group({

      Owner_First_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_First_Name), this.noHtmlTagsValidator.bind(this)]],
      Owner_Last_Name: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Last_Name), this.noHtmlTagsValidator.bind(this)]],
      //Owner_Preferred_First_Name: ['', Validators.required],
      Owner_Perc: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Perc), this.noHtmlTagsValidator.bind(this)]],
      Owner_Address1: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Address1), this.noHtmlTagsValidator.bind(this)]],
      Owner_Address2: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Address2), this.noHtmlTagsValidator.bind(this)]],
      Owner_City: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_City), this.noHtmlTagsValidator.bind(this)]],
      Owner_Country: [''],
      Owner_State: ['', Validators.required],
      Owner_Province: ['', Validators.required],
      Owner_Postal_Code: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Postal_Code), postalCodeValidator(() => this.section1Form.get('US_or_CA')?.value)]],
      Owner_Mobile_Phone: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Mobile_Phone), elevenDigitPhoneNumberValidator()]],
      Owner_Home_Phone: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Home_Phone), tenDigitPhoneNumberValidator()]],
      Owner_Email: ['', [Validators.maxLength(this.fieldMaxLengths.Owner_Email), this.noHtmlTagsValidator.bind(this)]]
    });


    this.section4Form = this.fb.group({
      Promoting_Owner: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.Promoting_Owner), this.noHtmlTagsValidator.bind(this)]],
      Promoting_Owner_Company: ['', [Validators.maxLength(this.fieldMaxLengths.Promoting_Owner_Company), this.noHtmlTagsValidator.bind(this)]],
      Regional_Consultant: ['', [Validators.maxLength(this.fieldMaxLengths.Regional_Consultant), this.noHtmlTagsValidator.bind(this)]],
      Regional_Consultant_Company: ['', [Validators.maxLength(this.fieldMaxLengths.Regional_Consultant_Company), this.noHtmlTagsValidator.bind(this)]],
      National_Consultant: ['', [Validators.required, Validators.maxLength(this.fieldMaxLengths.National_Consultant), this.noHtmlTagsValidator.bind(this)]],
      National_Consultant_Company: ['', [Validators.maxLength(this.fieldMaxLengths.National_Consultant_Company), this.noHtmlTagsValidator.bind(this)]],


      Loading_Dock: [''],
      Fork_Lift: [''],
      Straight_Truck_Required: [''],
      Appointment_Required: [''],
      Lift_Gate_Required: [''],

      Delivery_Contact_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Delivery_Contact_Name), this.noHtmlTagsValidator.bind(this)]],
      Alternate_Contact_Name: ['', [Validators.maxLength(this.fieldMaxLengths.Alternate_Contact_Name), this.noHtmlTagsValidator.bind(this)]],
      Hours_of_Operation: ['', [Validators.maxLength(this.fieldMaxLengths.Hours_of_Operation), this.noHtmlTagsValidator.bind(this)]],
      Best_Delivery_Time: [''],
      Special_Delivery_Requirements: ['', [Validators.maxLength(this.fieldMaxLengths.Special_Delivery_Requirements) ,this.noHtmlTagsValidator.bind(this)]],
      Company_Website: ['', [Validators.maxLength(this.fieldMaxLengths.Company_Website), this.noHtmlTagsValidator.bind(this)]],
      Payroll_Provider: [''],
      Payroll_Provider_other: ['', [Validators.maxLength(this.fieldMaxLengths.Payroll_Provider_other), this.noHtmlTagsValidator.bind(this)]]
    });


    this.section5Form = this.fb.group({
      Attach_US_Articles_of_Incorporation: ['', [Validators.required]],
      Attach_US_W_9: ['', [Validators.required]],
      //Attach_US_Node_Form: ['', [Validators.required]],
      //Attach_US_SS4_EIN: ['', [Validators.required]],
      //Attach_US_Void_Check_Bank_Account: ['', [Validators.required]],
      //Attach_US_Additional_Insurance: [''],
      //Attach_US_Form_8821: [''],
      //Attach_US_Homeowner_Insurance: [''],
      //Attach_US_ADP_Payroll: [''],
      Attach_US_Certificate_of_Insurance: [''],
      //Attach_US_Payroll_Setup: ['']
    });

    this.section6Form = this.fb.group({
      Attach_Canada_Articles_of_Incorporation: ['', [Validators.required]],
      //Attach_Canada_CRA_Consent: ['', [Validators.required]],
      //Attach_Canada_Bank_Account_statement: ['', [Validators.required]],
      //Attach_Canada_Worker_Compensation_Coverage: ['', [Validators.required]],
      //Attach_Canada_Insurance_Application: [''],
      //Attach_Canada_Additional_Insurance_Questionnaire: ['', [Validators.required]],
      //Attach_Canada_Homeowner_Insurance: [''],
      //Attach_Canada_ADP_Payroll: ['', [Validators.required]],
      //Attach_Canada_Out_of_Province_Qualification: [''],
      //Attach_Canada_Waddell_Privacy: [''],
      Attach_Canada_Certificate_of_Insurance: ['']
    });

    //this.icdForm.addControl('section1', this.section1Form);
    //this.icdForm.addControl('section2', this.section2Form);
    //this.icdForm.addControl('section3', this.section3Form);
    //this.icdForm.addControl('section4', this.section4Form);
    //this.icdForm.addControl('section5', this.section5Form);
    //this.icdForm.addControl('section6', this.section6Form);

  }

  sendDataToParent() {
    this.dataEmitter.emit(this.datad);
  }
  // convenience getter for easy access to form fields
  get f() { return this.icdForm.controls; }

  get s1() { return this.section1Form.controls; }

  get items(): FormArray {
    return this.icdForm.get('items') as FormArray;
  }


  onInputChange(value: string) {

    let sanitizedValue = value.replace(/\D/g, '');


    if (sanitizedValue.length > 9) {
      sanitizedValue = sanitizedValue.slice(0, 9);
    }


    this.icdForm.get('SSN_SIN')?.setValue(sanitizedValue);
    this.displayValue = sanitizedValue;
  }


  onBlur() {
    const value = this.icdForm.get('SSN_SIN')?.value || '';
    this.displayValue = this.maskSSN(value);
  }


  onFocus() {
    this.displayValue = this.icdForm.get('SSN_SIN')?.value || '';
  }

  maskSSN(value: string): string {
    if (value) {
      const sanitizedValue = value.replace(/\D/g, '');

      if (this.isUS && sanitizedValue.length === 9) {
        return 'XXX-XX-' + sanitizedValue.slice(-4);
      } else if (!this.isUS && sanitizedValue.length === 9) {

        return 'XXX-XXX-' + sanitizedValue.slice(-3);
      }
    }

    return value; // If less than 9 digits, return as is
  }



  ChangeIsInsurance() {

    this.isInsuranceRequired = this.icdForm.get('isInsuranceRequired').value;

    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      if (this.isInsuranceRequired === 'false') {

        this.icdForm.get('Attach_US_Certificate_of_Insurance').setValidators([Validators.required]);
        this.icdForm.get('Attach_Workers_Compensation').setValidators([Validators.required]);




      } else {

        this.icdForm.get('Attach_US_Certificate_of_Insurance').clearValidators();
        this.icdForm.get('Attach_Workers_Compensation').clearValidators();



      }

      this.icdForm.get('Attach_Workers_Compensation').updateValueAndValidity();
      this.icdForm.get('Attach_US_Certificate_of_Insurance').updateValueAndValidity();
    }
    else {
      if (this.isInsuranceRequired === 'false') {

        this.icdForm.get('Attach_Canada_Certificate_of_Insurance').setValidators([Validators.required]);
        this.icdForm.get('Attach_Canada_Worker_Compensation_Coverage').setValidators([Validators.required]);




      } else {

        this.icdForm.get('Attach_Canada_Certificate_of_Insurance').clearValidators();
        this.icdForm.get('Attach_Canada_Worker_Compensation_Coverage').clearValidators();



      }

      this.icdForm.get('Attach_Canada_Worker_Compensation_Coverage').updateValueAndValidity();
      this.icdForm.get('Attach_Canada_Certificate_of_Insurance').updateValueAndValidity();
    }
   
   
  }
  onCountryChange() {
    const US_or_CA = this.icdForm.get('US_or_CA').value;
    if (US_or_CA === 'US') {
      this.selectedCountry = "US";
      this.icdForm.get('State_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Provinence_of_Incorporation').clearValidators();

      this.icdForm.get('Owner_Country').setValidators([Validators.required]);
      this.icdForm.get('Owner_State').setValidators([Validators.required]);
      this.icdForm.get('Owner_Province').clearValidators();

      this.icdForm.get('Company_Country').setValidators([Validators.required]);
      this.icdForm.get('Company_State').setValidators([Validators.required]);
      this.icdForm.get('Company_Province').clearValidators();

      this.icdForm.get('Attach_US_Articles_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Attach_US_W_9').setValidators([Validators.required]);
      //this.icdForm.get('Attach_US_Node_Form').setValidators([Validators.required]);
      this.icdForm.get('Attach_US_SS4_EIN').setValidators([Validators.required]);
      this.icdForm.get('Attach_US_Void_Check_Bank_Account').setValidators([Validators.required]);

      this.icdForm.get('Attach_Canada_Articles_of_Incorporation').clearValidators();
      this.icdForm.get('Attach_Canada_Bank_Statement_or_Direct_Deposit').clearValidators();
      //this.icdForm.get('Attach_Canada_Bank_Account_statement').clearValidators();
      this.icdForm.get('Attach_Canada_Worker_Compensation_Coverage').clearValidators();
      //this.icdForm.get('Attach_Canada_Additional_Insurance_Questionnaire').clearValidators();
      //this.icdForm.get('Attach_Canada_ADP_Payroll').clearValidators();


    } else {
      this.selectedCountry = "Canada";
      this.icdForm.get('Provinence_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('State_of_Incorporation').clearValidators();


      this.icdForm.get('Owner_Country').clearValidators();
      this.icdForm.get('Owner_State').clearValidators();
      this.icdForm.get('Owner_Province').setValidators([Validators.required]);

      this.icdForm.get('Company_Country').clearValidators();
      this.icdForm.get('Company_State').clearValidators();
      this.icdForm.get('Company_Province').setValidators([Validators.required]);



      this.icdForm.get('Attach_Canada_Articles_of_Incorporation').setValidators([Validators.required]);
      this.icdForm.get('Attach_Canada_Bank_Statement_or_Direct_Deposit').setValidators([Validators.required]);
      //this.icdForm.get('Attach_Canada_Bank_Account_statement').setValidators([Validators.required]);
      //this.icdForm.get('Attach_Canada_Worker_Compensation_Coverage').setValidators([Validators.required]);
      //this.icdForm.get('Attach_Canada_Additional_Insurance_Questionnaire').setValidators([Validators.required]);
      //this.icdForm.get('Attach_Canada_ADP_Payroll').setValidators([Validators.required]);
      this.icdForm.get('Attach_US_Articles_of_Incorporation').clearValidators();
      this.icdForm.get('Attach_US_W_9').clearValidators();
      //this.icdForm.get('Attach_US_Node_Form').clearValidators();
      this.icdForm.get('Attach_US_SS4_EIN').clearValidators();
      this.icdForm.get('Attach_US_Void_Check_Bank_Account').clearValidators();


    }
    this.icdForm.get('Provinence_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('State_of_Incorporation').updateValueAndValidity();


    this.icdForm.get('Owner_Country').updateValueAndValidity();
    this.icdForm.get('Owner_State').updateValueAndValidity();
    this.icdForm.get('Owner_Province').updateValueAndValidity();

    this.icdForm.get('Company_Country').updateValueAndValidity();
    this.icdForm.get('Company_State').updateValueAndValidity();
    this.icdForm.get('Company_Province').updateValueAndValidity();


    this.icdForm.get('Attach_Canada_Articles_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('Attach_Canada_Bank_Statement_or_Direct_Deposit').updateValueAndValidity();
    //this.icdForm.get('Attach_Canada_Bank_Account_statement').updateValueAndValidity();
    this.icdForm.get('Attach_Canada_Worker_Compensation_Coverage').updateValueAndValidity();
    //this.icdForm.get('Attach_Canada_Additional_Insurance_Questionnaire').updateValueAndValidity();
    //this.icdForm.get('Attach_Canada_ADP_Payroll').updateValueAndValidity();
    this.icdForm.get('Attach_US_Articles_of_Incorporation').updateValueAndValidity();
    this.icdForm.get('Attach_US_W_9').updateValueAndValidity();
    //this.icdForm.get('Attach_US_Node_Form').updateValueAndValidity();
    this.icdForm.get('Attach_US_SS4_EIN').updateValueAndValidity();
    this.icdForm.get('Attach_US_Void_Check_Bank_Account').updateValueAndValidity();
  }
  onCheckboxPo(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.PO_namesData.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.icdForm.controls['Promoting_Owner_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['Promoting_Owner_Company'].setValue('');
      }

    }    
      

  }


  onCheckboxNC(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.NC_namesData.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.icdForm.controls['National_Consultant_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['National_Consultant_Company'].setValue('');
      }

    }


  }


  onCheckboxRC(selectElement) {

    if (selectElement != null) {
      const selectedIndex = this.RC_namesData.filter(item => item.ownerName == selectElement);


      if (selectedIndex.length >= 0) {
        this.icdForm.controls['Regional_Consultant_Company'].setValue(selectedIndex[0].name);
      } else {
        this.icdForm.controls['Regional_Consultant_Company'].setValue('');
      }

    }


  }

  onPayrollProviderChange(selectedValue: string) {
    if (selectedValue === 'Other (Not Listed)') {
      this.isPayrollProviderOther = true;
      this.icdForm.get('Payroll_Provider_other').setValidators([Validators.required]);
    } else {
      this.isPayrollProviderOther = false;
      this.icdForm.get('Payroll_Provider_other').clearValidators();
      this.icdForm.get('Payroll_Provider_other').setValue('');
    }
    this.icdForm.get('Payroll_Provider_other').updateValueAndValidity();
  }

   

   
   

  onCheckboxChange_US_Retails(event: any, value: any) {
  
    if (event.target.checked) {
      this.US_Retails_selectedItems.push(value);
    } else {
      const index = this.US_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Retails_selectedItems.length <= 0) {
      this.US_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Retails_isSelectedItemsinvalid = false;
    }

    // Update the selectedRetailers array with the latest selections
    this.selectedRetailers = this.US_Retails_selectedItems;
   
  }


  onCheckboxChange_Canada_Retails(event: any, value: any) {
    if (event.target.checked) {
      this.Canada_Retails_selectedItems.push(value);
    } else {
      const index = this.Canada_Retails_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Retails_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Retails_selectedItems.length <= 0) {
      this.Canada_Retails_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Retails_isSelectedItemsinvalid = false;
    }


  }



  Showsuccesspopup1(str: string) {
    Swal.fire({
      title: str,
      icon: 'error',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {
          
          //location.reload();
        }
      },
    }).then((result) => {

    });
  }

  onCheckboxChange_US_Campaigns(event: any, value: any) {
    
    if (event.target.checked) {

      

      let dueDiligence = this.US_campaignData_DD.filter(a => a.dueDiligenceRequired == "Yes" && a.campaignName  == value);;

      if (dueDiligence.length > 0) {

        let ownername = this.icd.Owner_First_Name + " " + this.icd.Owner_Last_Name;
        if (this.icd.Owner_Preferred_First_Name != null && this.icd.Owner_Preferred_Last_Name != null) {
          ownername = this.icd.Owner_Preferred_First_Name + " " + this.icd.Owner_Preferred_Last_Name;
        }
        if (this.isReopenCase) {
          this.sfDataService.CheckDueDeligRequiredMyOwnOffice(this.icd.PromotingOwner, value, ownername).subscribe(resp => {
            //console.log(resp);

            if (resp.length <= 0) {

              this.alertService.showMessage('Cannot select this campaign, as it requires due diligence.', '.', MessageSeverity.error);
              this.Showsuccesspopup1('Cannot select this campaign, as it requires due diligence.');
              // Uncheck the checkbox
              event.target.checked = false;
              return;
            }

            if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
              this.isTestCampaign = true;
              this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required, this.noHtmlTagsValidator.bind(this)]);
              this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

            }
            this.US_Campaigns_selectedItems.push(value);
          });
        }
        else {
          this.sfDataService.CheckDueDeligRequired(this.icd.PromotingOwner, value, ownername).subscribe(resp => {
            //console.log(resp);

            if (resp.length <= 0) {

              this.alertService.showMessage('Cannot select this campaign, as it requires due diligence.', '.', MessageSeverity.error);
              this.Showsuccesspopup1('Cannot select this campaign, as it requires due diligence.');
              // Uncheck the checkbox
              event.target.checked = false;
              return;
            }

            if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
              this.isTestCampaign = true;
              this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
              this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

            }
            this.US_Campaigns_selectedItems.push(value);
          });

        }



      }
      else {
        if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
          this.isTestCampaign = true;
          this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
          this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

        }
        this.US_Campaigns_selectedItems.push(value);
      }


    }
    else {
      if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
        this.isTestCampaign = false;
        this.icdForm.get('TestCampaignNotListed').clearValidators();
        this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      }
      const index = this.US_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.US_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.US_Campaigns_selectedItems.length <= 0) {
      this.US_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.US_Campaigns_isSelectedItemsinvalid = false;
    }


  }


  onCheckboxChange_Canada_Campaigns(event: any, value: any) {
    if (event.target.checked) {




      let dueDiligence = this.Canada_campaignData_DD.filter(a => a.dueDiligenceRequired == "Yes" && a.campaignName == value);;

      if (dueDiligence.length > 0) {

        let ownername = this.icd.Owner_First_Name + " " + this.icd.Owner_Last_Name;
        if (this.icd.Owner_Preferred_First_Name != null && this.icd.Owner_Preferred_Last_Name != null) {
          ownername = this.icd.Owner_Preferred_First_Name + " " + this.icd.Owner_Preferred_Last_Name;
        }
        if (this.isReopenCase) {
          this.sfDataService.CheckDueDeligRequiredMyOwnOffice(this.icd.PromotingOwner, value, ownername).subscribe(resp => {
            //console.log(resp);

            if (resp.length <= 0) {

              this.alertService.showMessage('Cannot select this campaign, as it requires due diligence.', '.', MessageSeverity.error);
              this.Showsuccesspopup1('Cannot select this campaign, as it requires due diligence.');
              // Uncheck the checkbox
              event.target.checked = false;
              return;
            }

            if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
              this.isTestCampaign = true;
              this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
              this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

            }
            this.Canada_Campaigns_selectedItems.push(value);
          });
        }
        else {
          this.sfDataService.CheckDueDeligRequired(this.icd.PromotingOwner, value, ownername).subscribe(resp => {
            //console.log(resp);

            if (resp.length <= 0) {

              this.alertService.showMessage('Cannot select this campaign, as it requires due diligence.', '.', MessageSeverity.error);
              this.Showsuccesspopup1('Cannot select this campaign, as it requires due diligence.');
              // Uncheck the checkbox
              event.target.checked = false;
              return;
            }

            if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
              this.isTestCampaign = true;
              this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
              this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

            }
            this.Canada_Campaigns_selectedItems.push(value);
          });
        }


      }
      else {
        if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
          this.isTestCampaign = true;
          this.icdForm.get('TestCampaignNotListed').setValidators([Validators.required]);
          this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();

        }
        this.Canada_Campaigns_selectedItems.push(value);
      }




    } else {
      if (value == "TestCampaign(NotListed)" || value == "Other (Not Listed)") {
        this.isTestCampaign = false;
        this.icdForm.get('TestCampaignNotListed').clearValidators();
        this.icdForm.get('TestCampaignNotListed').updateValueAndValidity();
      }
      const index = this.Canada_Campaigns_selectedItems.indexOf(value);
      if (index > -1) {
        this.Canada_Campaigns_selectedItems.splice(index, 1);
      }
    }


    if (this.Canada_Campaigns_selectedItems.length <= 0) {
      this.Canada_Campaigns_isSelectedItemsinvalid = true;
    }
    else {
      this.Canada_Campaigns_isSelectedItemsinvalid = false;
    }


  }

  showErrorAlert(caption: string, message: string) {
    this.alertService.showMessage(caption, message, MessageSeverity.error);
  }

  // Front-end displays dates as MM-DD-YYYY; Salesforce stores them as YYYY-MM-DD.
  // Convert a UI MM-DD-YYYY value to YYYY-MM-DD before saving. Idempotent/safe for
  // empty or already-normalized values.
  private toSfDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{2})-(\d{2})-(\d{4})$/.exec(v.trim());
    return m ? `${m[3]}-${m[1]}-${m[2]}` : v;
  }

  // Convert a Salesforce YYYY-MM-DD (optionally with a time component) to the
  // MM-DD-YYYY the datepicker/UI expects. Safe for empty/invalid values.
  private toDisplayDate(v: string): string {
    if (!v) { return v; }
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(v.trim());
    return m ? `${m[2]}-${m[3]}-${m[1]}` : v;
  }

  ngAfterViewInit() {

    this.datepicker = $('#Date_of_Incorporation').datepicker({
      dateFormat: 'mm-dd-yy',
      changeMonth: true,
      changeYear: true,
      maxDate: 0,
      onSelect: (dateText, inst) => {
        this.datepicker = dateText;
        this.icdForm.controls['Date_of_Incorporation'].patchValue(dateText);
        this.icdForm.controls['Date_of_Incorporation'].markAsTouched();
        this.icdForm.controls['Date_of_Incorporation'].updateValueAndValidity();
      }
    });
     

    for (const item of this.US_campaignData) {
      if (this.US_savedCampaignsString.includes(item.campaignName)) {
        const checkbox = this.el.nativeElement.querySelector(`#${item.id}`);
        this.renderer.setProperty(checkbox, 'checked', true);
        //this.selectedCampaignsControl.value.push(item.campaignName);
      }
    }
  }

  closeModal() {
    if (this.modalClosedCallback) {
      this.modalClosedCallback();
    }
  }

  onSubmit() {
    this.hintStateService.collapse();

    this.submitted = true;

    // FR1: do not submit while a file is still uploading to staging.
    if (this.hasUploadsInFlight()) {
      this.alertService.showMessage('Please wait', 'A file is still uploading. Please wait until it finishes before submitting.', MessageSeverity.error);
      this.Showsuccesspopup1('A file is still uploading. Please wait until it finishes before submitting.');
      return;
    }

    this.trimFormValues();

    if (this.selectedCountry === 'US') {

      if (this.US_Campaigns_selectedItems.length <= 0) {
        this.US_Campaigns_isSelectedItemsinvalid = true;
      }
      else {
        this.US_Campaigns_isSelectedItemsinvalid = false;
      }


      if (this.US_Retails_selectedItems.length <= 0) {
        this.US_Retails_isSelectedItemsinvalid = false;//making it false as we are hiding it
      }
      else {
        this.US_Retails_isSelectedItemsinvalid = false;
      }


    }
    else {

      if (this.Canada_Campaigns_selectedItems.length <= 0) {
        this.Canada_Campaigns_isSelectedItemsinvalid = true;
      }
      else {
        this.Canada_Campaigns_isSelectedItemsinvalid = false;
      }


      if (this.Canada_Retails_selectedItems.length <= 0) {
        this.Canada_Retails_isSelectedItemsinvalid = false;//making it false as we are hiding it
      }
      else {
        this.Canada_Retails_isSelectedItemsinvalid = false;
      }


    }


    //const allContainAssurance = this.US_Campaigns_selectedItems.every(value => value.includes("ASSURANCE"));
    //const allContainAssurance = this.US_Campaigns_selectedItems.some(value => value.toLowerCase().includes("assurance"));


    //if (allContainAssurance && this.US_Campaigns_selectedItems.length > 0) {
    //  this.icdForm.get('Attach_US_Node_Form').setValidators([Validators.required]);
    //  this.icdForm.get('Attach_US_Node_Form').updateValueAndValidity();

    //} else {
    //  this.icdForm.get('Attach_US_Node_Form').clearValidators();
    //  this.icdForm.get('Attach_US_Node_Form').updateValueAndValidity();

    //}

    this.icdForm.get('Disability_Form').clearValidators();
    this.icdForm.get('Male_Emp').clearValidators();
    this.icdForm.get('FeMale_Emp').clearValidators();

    this.icdForm.get('Male_Emp').updateValueAndValidity();
    this.icdForm.get('FeMale_Emp').updateValueAndValidity();
    this.icdForm.get('Disability_Form').updateValueAndValidity();

    const State_of_Incorporation = this.icdForm.get('State_of_Incorporation').value;
    if (State_of_Incorporation === 'NY' || State_of_Incorporation === 'HI') {

      if (this.isInsuranceRequired === 'false') {

        //this.icdForm.get('Disability_Form').setValidators([Validators.required]);
        //this.icdForm.get('Male_Emp').clearValidators();
        //this.icdForm.get('FeMale_Emp').clearValidators();
        //let Disability_Form = this.icdForm.get('Disability_Form').value;
        //this.icdForm.get('Male_Emp').updateValueAndValidity();
        //this.icdForm.get('FeMale_Emp').updateValueAndValidity();
        //this.icdForm.get('Disability_Form').updateValueAndValidity();
        //if (Disability_Form == null) {
        //  this.alertService.showMessage('ICD', `Disability Form is mandatory.`, MessageSeverity.error);
        //  return;
        //}
        //this.icdForm.get('Attach_Workers_Compensation').setValidators([Validators.required]);




      } else {
        //this.icdForm.get('Disability_Form').clearValidators();
        //this.icdForm.get('Male_Emp').setValidators([Validators.required]);
        //this.icdForm.get('FeMale_Emp').setValidators([Validators.required]);
        //let Male_Emp = this.icdForm.get('Male_Emp').value;
        //let FeMale_Emp = this.icdForm.get('FeMale_Emp').value;
        //this.icdForm.get('Male_Emp').updateValueAndValidity();
        //this.icdForm.get('FeMale_Emp').updateValueAndValidity();
        //this.icdForm.get('Disability_Form').updateValueAndValidity();
        //if (Male_Emp == null || FeMale_Emp == null) {
        //  this.alertService.showMessage('ICD', `# of Male & Female Employees fields are mandatory.`, MessageSeverity.error);
        //  return;
        //}
        //this.icdForm.get('Attach_Workers_Compensation').clearValidators();



      }

    


    }


    if ((this.selectedCountry === 'US' && (this.US_Campaigns_isSelectedItemsinvalid || this.US_Retails_isSelectedItemsinvalid)) ||
      (this.selectedCountry !== 'US' && (this.Canada_Campaigns_isSelectedItemsinvalid || this.Canada_Retails_isSelectedItemsinvalid))) {

      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      //this.alertService.showMessage('Enter Mandatory fields', commaSeparated, MessageSeverity.error);
      this.alertService.showMessage('at least select one option in Campaigns', '', MessageSeverity.error);
      this.Showsuccesspopup1('at least select one option in Campaigns');
      // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();

      return;
    }

    // Check if Campaigns, Retailers, and form are invalid
    if ((this.selectedCountry === 'US' && (this.US_Campaigns_isSelectedItemsinvalid || this.US_Retails_isSelectedItemsinvalid)) ||
      (this.selectedCountry !== 'US' && (this.Canada_Campaigns_isSelectedItemsinvalid || this.Canada_Retails_isSelectedItemsinvalid)) ||
      this.icdForm.invalid) {

      const formControls = this.icdForm.controls;

      // Initialize an array to store invalid controls
      const invalidControls: string[] = [];

      // Iterate through the form controls and check if they are invalid
      Object.keys(formControls).forEach(controlName => {
        const control = this.icdForm.get(controlName);

        if (control?.invalid) {
          let displayName =
            this.controlDisplayNames[controlName] || controlName;

          if (control.errors?.invalidHtml) {
            displayName += ' (HTML/script not allowed)';
          }

          invalidControls.push(displayName);
        }
      });

      // Now, the 'invalidControls' array contains the names of all invalid form controls
      ////console.log('Invalid controls:', invalidControls);
      const commaSeparated = invalidControls.join(', ');

        // Mark all fields as touched to display validation errors
      this.icdForm.markAllAsTouched();
      this.alertService.showMessage('Enter required fields', commaSeparated, MessageSeverity.error);
      this.Showsuccesspopup1('Enter required fields :' + commaSeparated);
      return;
    }

    // Trigger AI pre-submit review before final save
    this.showPreSubmitReview = true;
    this.runPreSubmitReview();

  }

  private buildFormSnapshot(): Record<string, string> {
    const raw = this.icdForm.getRawValue();
    const snap: Record<string, string> = {};
    Object.keys(raw).forEach(k => {
      const ctrl = this.icdForm.get(k);
      if (ctrl && ctrl.disabled) { return; } // skip disabled/read-only fields — user cannot act on the advisory
      const v = raw[k];
      if (v !== null && v !== undefined && typeof v !== 'object') {
        snap[k] = String(v);
      }
    });
    return snap;
  }

  runPreSubmitReview(): void {
    this.preSubmitLoading = true;
    this.preSubmitIssues = [];

    // Client-side owner name check (regex is more reliable than AI for this)
    const invalidNameChars = /[0-9@#$%^&*()+={\[\]}|\\<>]/;
    [{ field: 'Owner_First_Name', label: 'Owner First Name' },
     { field: 'Owner_Middle_Name', label: 'Owner Middle Name' },
     { field: 'Owner_Last_Name', label: 'Owner Last Name' }].forEach(n => {
      const val = (this.icdForm.get(n.field)?.value ?? '') as string;
      if (val && invalidNameChars.test(val)) {
        this.preSubmitIssues.push({
          fieldName: n.field, label: n.label,
          issue: 'Name contains invalid characters (digits or symbols)',
          severity: 'error', suggestedFix: null, canAutoFix: false
        });
      }
    });

    // Generic Angular validator sweep — picks up any validator that returns a rich error
    // object with { label, message, suggestedFix, canAutoFix }. No field names needed here.
    Object.keys(this.icdForm.controls).forEach(fieldName => {
      const ctrl = this.icdForm.get(fieldName);
      if (!ctrl || !ctrl.invalid || !ctrl.errors) return;
      const firstErrorKey = Object.keys(ctrl.errors)[0];
      const errVal = ctrl.errors[firstErrorKey];
      if (errVal === null || typeof errVal !== 'object' || !('message' in errVal)) return;
      this.preSubmitIssues.push({
        fieldName,
        label: errVal.label ?? fieldName,
        issue: errVal.message,
        severity: 'error',
        suggestedFix: errVal.suggestedFix ?? null,
        canAutoFix: errVal.canAutoFix ?? false,
      });
    });

    this.preSubmitIssues = [...this.preSubmitIssues, ...this.buildVerificationIssues()];

    this.agentService.getPreSubmitReview(this.buildFormSnapshot()).subscribe({
      next: (res: any) => {
        // Merge AI results with client-side name issues (collected above)
        this.preSubmitIssues = [...this.preSubmitIssues, ...(res.issues ?? [])];
        this.preSubmitLoading = false;
        // Scroll to top so the sticky warning banner is visible
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // Mark form controls with AI errors so field borders turn red
        this.preSubmitIssues.forEach(issue => {
          if (issue.severity === 'error') {
            const ctrl = this.icdForm.get(issue.fieldName);
            if (ctrl) {
              ctrl.setErrors({ aiReview: issue.issue });
              ctrl.markAsTouched();
            }
          }
        });
      },
      error: () => {
        this.preSubmitIssues = [];
        this.preSubmitLoading = false;
      }
    });
  }

  private buildVerificationIssues(): PreSubmitIssue[] {
    const docLabels: { [key: string]: string } = {
      Attach_US_W_9: 'W-9 Document',
      Attach_US_Articles_of_Incorporation: 'Articles of Incorporation (US)',
      Attach_US_Void_Check_Bank_Account: 'Void Check / Bank Account',
      Attach_US_Certificate_of_Insurance: 'Certificate of Insurance (US)',
      Attach_Canada_Articles_of_Incorporation: 'Articles of Incorporation (Canada)',
      Attach_Canada_Bank_Statement_or_Direct_Deposit: 'Bank Statement / Direct Deposit',
      Attach_Canada_Certificate_of_Insurance: 'Certificate of Insurance (Canada)',
    };
    const issues: PreSubmitIssue[] = [];
    Object.entries(this.verificationState).forEach(([controlName, state]) => {
      if (state !== 'fail' && state !== 'warn') return;
      const label = docLabels[controlName] ?? controlName;
      const fieldIssues = this.verificationIssues[controlName] ?? [];
      if (fieldIssues.length > 0) {
        fieldIssues.forEach(issue => issues.push({
          fieldName: controlName, label,
          issue, severity: 'warning', suggestedFix: null, canAutoFix: false
        }));
      } else {
        issues.push({
          fieldName: controlName, label,
          issue: state === 'fail' ? 'Document verification failed' : 'Document accepted with notes',
          severity: 'warning', suggestedFix: null, canAutoFix: false
        });
      }
    });
    return issues;
  }

  get preSubmitWarnings(): PreSubmitIssue[] {
    return this.preSubmitIssues.filter(i => i.severity === 'warning');
  }

  onPreSubmitDismiss(): void {
    // Clear AI-set errors before hiding the panel
    this.preSubmitIssues.forEach(issue => {
      if (issue.severity === 'error') {
        const ctrl = this.icdForm.get(issue.fieldName);
        if (ctrl) { ctrl.setErrors(null); ctrl.updateValueAndValidity(); }
      }
    });
    this.showPreSubmitReview = false;
  }

  onPreSubmitDoSubmit(): void {
    // Clear AI-set errors before actual submit
    this.preSubmitIssues.forEach(issue => {
      if (issue.severity === 'error') {
        const ctrl = this.icdForm.get(issue.fieldName);
        if (ctrl) { ctrl.setErrors(null); ctrl.updateValueAndValidity(); }
      }
    });
    this.showPreSubmitReview = false;
    this.saveData(true);
  }

  onPreSubmitRecheck(): void {
    this.runPreSubmitReview();
  }

  onPreSubmitAutoFix(issue: PreSubmitIssue): void {
    const ctrl = this.icdForm.get(issue.fieldName);
    if (issue.suggestedFix != null && ctrl) {
      ctrl.setValue(issue.suggestedFix, { emitEvent: true });
      ctrl.markAsDirty();
      ctrl.markAsTouched();
    }
    this.runPreSubmitReview();
  }

  onPreSubmitNavigate(fieldName: string): void {
    this.showPreSubmitReview = false;
    setTimeout(() => {
      const el =
        document.querySelector<HTMLElement>(`[formControlName="${fieldName}"]`) ??
        document.querySelector<HTMLElement>(`#${fieldName}`);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        el.focus?.();
      }
    }, 180);
  }

  fileValidator(control: any) {
    const files = control.value;
    
    if (!files || files.length === 0) {
      return null;
    }
    if (files.length + this.fileData.length > this.maxFilesAllowed) {
      return { maxFilesExceeded: true };
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!this.isValidFileFormat(file)) {
        return { invalidFormat: true };
      }

      if (file.size > this.maxFileSize) {
        return { fileSizeExceeded: true };
      }
    }

    return null;
  }

  //onFileSelected(event: any, inputId: string) {

  //  const files = event.target.files;


  //  for (let i = 0; i < files.length; i++) {
  //    const file = files[i];

  //    if (!this.isValidFileFormat(file)) {
  //      //console.log('Invalid file format:', file.name);
  //      this.icdForm.get('Attach_US_Articles_of_Incorporation').setErrors({ invalidFormat: true });

  //      continue;
  //    }

  //    const reader = new FileReader();
  //    reader.readAsDataURL(file);

  //    reader.onload = () => {
  //      const base64 = reader.result.toString().split(',')[1];
  //      this.fileData.push({ name: file.name, base64 });

  //      // Update the 'Attach_1' form control with the selected file name
  //      this.icdForm.patchValue({ Attach_US_Articles_of_Incorporation: file.name });

  //    };
  //  }

  //  this.uploadFiles();
  //}

  
  onFileSelected(event: any, controlName: string) {
    const files = event.target.files;
    const errors = [];
    const errorMessages: string[] = [];

    // Remove previously selected files for this control
    this.fileData = this.fileData.filter(file => file.attachment_Type !== controlName);
    delete this.verificationState[controlName];
    delete this.verificationIssues[controlName];

    if (!files || files.length === 0) {
      this.icdForm.get(controlName).setErrors({ noFileSelected: true });
      this.icdForm.get(controlName).updateValueAndValidity();
      return;
    }

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      // Check for valid file format
      if (!this.isValidFileFormat(file)) {
        errorMessages.push(
          `Invalid file format for "${file.name}". 
     Allowed formats: all image files (JPG, PNG, HEIC, etc.), PDF, Word (DOC, DOCX), Excel (XLS, XLSX), and CSV.`
        );

        //console.log('Invalid file format:', file.name);
        errors.push({ invalidFormat: true });
      }

      // Check for file size limit
      if (file.size > this.maxFileSize) {
        errorMessages.push(`File size exceeds 25 MB limit for file "${file.name}".`);

        //console.log('File size exceeds the limit:', file.name);
        errors.push({ fileSizeExceeded: true });
      }
    }

    // Set errors if any exist
    if (errors.length > 0) {
      const combinedMessage = errorMessages.join('\n');

      this.alertService.showMessage(combinedMessage, '.', MessageSeverity.error);
      this.Showsuccesspopup1(combinedMessage);
      this.icdForm.get(controlName).setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      const control = this.icdForm.get(controlName);
      // 🔥 CRITICAL FIX
      control?.setValue(null);
      control?.setErrors(errors.reduce((acc, curr) => ({ ...acc, ...curr }), {}));
      control?.markAsTouched();
      control?.updateValueAndValidity({ emitEvent: false });

      // optional: clear DOM input too
      event.target.value = '';
      return; // 👈 stop here
    } else {
      // ---------- SUCCESS: upload each file to staging on select (FR1) ----------
      this.uploadState[controlName] = 'uploading';
      this.uploadError[controlName] = '';
      const inputEl = event.target as HTMLInputElement;
      // Bump the selection counter; a superseded selection's FileReader result is discarded (FR2).
      const seq = this.uploadSeq[controlName] = (this.uploadSeq[controlName] || 0) + 1;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => {
          if (this.uploadSeq[controlName] !== seq) { return; } // a newer selection superseded this one
          const b64 = reader.result!.toString().split(',')[1];
          const entry: { attachment_FileName: string, attachment_Base64: string, attachment_Type: string, FileId?: string, Url?: string, status?: 'uploading' | 'uploaded' | 'error' } = {
            attachment_FileName: file.name,
            attachment_Base64: b64,
            attachment_Type: controlName,
            status: 'uploading'
          };
          this.fileData.push(entry);
          this.triggerDocumentVerification(controlName);
          this.stageFile(entry, controlName, inputEl);
        };
      }

      this.icdForm.get(controlName).setErrors(null);
    }

    // Update form control validity
    this.icdForm.get(controlName).updateValueAndValidity();
  }

  // Uploads a single file to the staging area. A response from a previously replaced/cancelled
  // upload is ignored via object identity: if the entry is no longer in fileData, discard it (FR2).
  private stageFile(entry: any, controlName: string, inputEl: HTMLInputElement): void {
    // Owner name / Tax ID must come from the live form (populated on load), not this.icd
    const firstName = this.icdForm?.get('Owner_First_Name')?.value || this.icd?.Owner_First_Name || '';
    const lastName = this.icdForm?.get('Owner_Last_Name')?.value || this.icd?.Owner_Last_Name || '';
    const body = {
      CaseID: this.icd?.CaseID || this.icd?.AccountID || '',
      Attachment_FileName: entry.attachment_FileName,
      Attachment_Base64: entry.attachment_Base64,
      Owner_Email: this.icdForm?.get('Owner_Email')?.value || this.icd?.Owner_Email || this.icdForm?.get('Company_Business_Email')?.value || this.icd?.Company_Business_Email || this.icdForm?.get('HUB_Manager_Contact_Email')?.value || this.icd?.HUB_Manager_Contact_Email || this.icd?.HUB_Assistance_Email || '',
      Owner_Name: (firstName + ' ' + lastName).trim(),
      Tax_ID: this.icdForm?.get('Tax_ID')?.value || this.icd?.Tax_ID || ''
    };

    entry.StagingUniqueId = body.CaseID;

    this.sfDataService.stageAttachment(body).subscribe({
      next: (res: any) => {
        if (!this.fileData.includes(entry)) { return; } // superseded by a newer selection (FR2)
        if (res && res.isSuccess) {
          entry.FileId = res.fileId;
          entry.Url = res.url;
          entry.status = 'uploaded';
        } else {
          entry.status = 'error';
          this.removeStagedEntry(entry, inputEl);
          this.uploadError[controlName] = (res && res.errorMessage) ? res.errorMessage : 'Upload failed — please re-select the file.';
        }
        this.recomputeUploadState(controlName);
      },
      error: (err: any) => {
        if (!this.fileData.includes(entry)) { return; }
        entry.status = 'error';
        this.removeStagedEntry(entry, inputEl);
        this.uploadError[controlName] = this.extractServerError(err);
        this.recomputeUploadState(controlName);
      }
    });
  }

  // FR5: a failed file must not be silently submitted — drop it and force a re-select.
  private removeStagedEntry(entry: any, inputEl: HTMLInputElement): void {
    this.fileData = this.fileData.filter(f => f !== entry);
    const control = this.icdForm.get(entry.attachment_Type);
    if (inputEl) { inputEl.value = ''; }
    if (control?.hasValidator?.(Validators.required)) {
      control.setErrors({ required: true });
    }
    control?.markAsTouched();
  }

  private recomputeUploadState(controlName: string): void {
    const entries = this.fileData.filter(f => f.attachment_Type === controlName);
    if (entries.some(e => e.status === 'uploading')) {
      this.uploadState[controlName] = 'uploading';
    } else if (entries.length > 0 && entries.every(e => e.status === 'uploaded')) {
      this.uploadState[controlName] = 'uploaded';
      this.uploadError[controlName] = '';
    } else if (entries.length === 0 && this.uploadError[controlName]) {
      this.uploadState[controlName] = 'error';
    } else if (entries.length === 0) {
      delete this.uploadState[controlName];
    }
  }

  private extractServerError(err: any): string {
    try {
      if (err?.error?.errorMessage) { return err.error.errorMessage; }
      if (typeof err?.error === 'string' && err.error) { return err.error; }
      if (err?.message) { return err.message; }
    } catch { /* ignore */ }
    return 'Upload failed — please re-select the file.';
  }

  // FR1: block submission while any staged upload is still resolving.
  hasUploadsInFlight(): boolean {
    return this.fileData.some(f => f.status === 'uploading');
  }

  /** Returns true if any verified document control currently has status 'verifying' or 'fail'. */
  get hasDocVerificationBlock(): boolean {
    return Object.values(this.verificationState).some(s => s === 'verifying' || s === 'fail');
  }

  private triggerDocumentVerification(controlName: string): void {
    const docType = this.VERIFIED_DOC_TYPES[controlName];
    if (!docType) return; // not a verified doc type

    // Use the first file for this control
    const fileEntry = this.fileData.find(f => f.attachment_Type === controlName);
    if (!fileEntry) return;

    this.verificationState[controlName] = 'verifying';
    this.verificationIssues[controlName] = [];

    const formValues = this.icdForm.getRawValue();
    const mimeType = this.getMimeType(this.getFileExtension(fileEntry.attachment_FileName));

    const body = {
      documentType: docType,
      base64Content: fileEntry.attachment_Base64,
      mimeType: mimeType,
      companyName: formValues.Full_Legal_Company_Name || '',
      taxId: formValues.Tax_ID || '',
      stateOfIncorporation: formValues.State_of_Incorporation || '',
      provinceOfIncorporation: formValues.Provinence_of_Incorporation || '',
      dateOfIncorporation: formValues.Date_of_Incorporation || '',
    };

    this.sfDataService.verifyDocument(body).subscribe({
      next: (result: any) => {
        if (result.overallPass) {
          this.verificationState[controlName] = result.issues && result.issues.length > 0 ? 'warn' : 'pass';
        } else {
          this.verificationState[controlName] = 'warn';
        }
        this.verificationIssues[controlName] = result.issues || [];
      },
      error: () => {
        // On network error, don't block — show a warning
        this.verificationState[controlName] = 'warn';
        this.verificationIssues[controlName] = ['Document verification unavailable — please verify manually.'];
      }
    });
  }

  isInvalid(controlName: string): boolean {
    const control = this.icdForm.get(controlName);
    return control.touched && control.invalid;
  }


  public openFile(name: string, type: string): void {
    this.getBase64DownloadUrl(name, type).then((url: string) => {
      window.open(url, '_blank');
    });
  }

  public getBase64DownloadUrl(name: string, type: string): Promise<string> {
    const file = this.fileData.find(f => f.attachment_FileName === name && f.attachment_Type === type);

    if (file) {
      const fileExtension = this.getFileExtension(name);
      const mimeType = this.getMimeType(fileExtension);
      const base64Data = file.attachment_Base64;

      return Promise.resolve(`data:${mimeType};base64,${base64Data}`);
    } else {
      return Promise.reject(new Error('File not found.'));
    }
  }


  private getFileExtension(fileName: string): string {
    const fileExtension = fileName.split('.').pop().toLowerCase();
    return fileExtension;
  }


  private getMimeType(fileExtension: string): string {
    // Map the file extension to the corresponding MIME type
    const mimeTypeMap = {
      pdf: 'application/pdf',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      xls: 'application/vnd.ms-excel',
      csv: 'text/csv'
    };

    return mimeTypeMap[fileExtension];
  }


  isValidFileFormat(file: File): boolean {
    const allowedMimePrefixes = [
      'image/' // all image types (jpg, png, heic, webp, etc.)
    ];

    const allowedExactMimeTypes = [
      // PDF
      'application/pdf',

      // Word
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

      // Excel
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

      // CSV (different browsers report it differently)
      'text/csv',
      'application/csv',
      'text/plain'
    ];

    // 1️⃣ Primary check (modern browsers)
    if (file.type) {
      if (allowedMimePrefixes.some(prefix => file.type.startsWith(prefix))) {
        return true;
      }

      if (allowedExactMimeTypes.includes(file.type)) {
        return true;
      }
    }

    // 2️⃣ Fallback (Safari / iOS / older browsers)
    const allowedExtensions = [
      // images
      'jpg', 'jpeg', 'png', 'gif', 'webp', 'heic', 'heif',

      // documents
      'pdf', 'doc', 'docx',

      // excel
      'xls', 'xlsx',

      // csv
      'csv'
    ];

    const extension = file.name.split('.').pop()?.toLowerCase();
    return !!extension && allowedExtensions.includes(extension);
  }


  uploadFiles() {
    //const formData = new FormData();

    //for (let i = 0; i < this.validFiles.length; i++) {
    //  formData.append('files[]', this.validFiles[i]);
    //}

    //console.log(this.fileData)
    //this.http.post('https://example.com/upload', formData).subscribe(
    //  (response) => {
    //    //console.log('Upload successful', response);
    //  },
    //  (error) => {
    //    //console.log('Upload error', error);
    //  }
    //);
  }


  // Check if the first five fields are valid
  areFirstFiveFieldsValid(firstFiveFields:any): boolean {
    

    for (const fieldName of firstFiveFields) {
      const fieldControl = this.icdForm.get(fieldName);
      if (fieldControl && fieldControl.invalid) {
        return false;
      }
    }

    return true;
  }

  // Example implementation of getErrorMessage function
  getErrorMessage(fieldName: string): string {
    const control = this.icdForm.get(fieldName);

    if (control?.errors) {
      if (control.errors.required) {
        return 'This field is required.';
      }

      if (control.errors.invalidHtml) {
        return 'HTML or script content is not allowed.';
      }
      // Add additional error messages for specific validation rules as needed
    }

    return 'Invalid field.';
  }

  saveData(isSubmitted: boolean) {
    //debugger;
    this.isLoading = true;
    this.btnDisplay = false;
    this.alertService.startLoadingMessage('', 'Data Submitting...');

    // Get the form values as an object
    const formValues = this.icdForm.getRawValue();



    // Set the properties of the ICD instance with the form values
    this.icd.US_or_CA = formValues.US_or_CA;
    this.icd.Full_Legal_Company_Name = formValues.Full_Legal_Company_Name;
   // this.icd.Years_in_Business = formValues.Years_in_Business;
    
    this.icd.Tax_ID = formValues.Tax_ID;

    this.icd.Company_Address1 = formValues.Company_Address1;
    this.icd.Company_Address2 = formValues.Company_Address2;
    this.icd.Company_City = formValues.Company_City;
    this.icd.Company_Postal_Code = formValues.Company_Postal_Code;
    this.icd.Company_Office_Phone = formValues.Company_Office_Phone;
    this.icd.Company_Business_Email = formValues.Company_Business_Email;
    this.icd.Company_Country = formValues.Company_Country;
    this.icd.Company_State = formValues.Company_State;
    this.icd.Company_Province = formValues.Company_Province;


    this.icd.Owner_First_Name = formValues.Owner_First_Name;
    this.icd.Owner_Last_Name = formValues.Owner_Last_Name;
    this.icd.Owner_Middle_Name = formValues.Owner_Middle_Name;
    //this.icd.Owner_Preferred_First_Name = formValues.Owner_Preferred_First_Name;

    this.icd.Preferred_Name_Different_from_Legal_Name__c = formValues.Is_Preferred_Differ;

    this.icd.Owner_Preferred_First_Name = formValues.Owner_Preferred_First_Name;
    this.icd.Owner_Preferred_Last_Name = formValues.Owner_Preferred_Last_Name;
    this.icd.Owner_Perc = formValues.Owner_Perc;
    this.icd.Owner_Address1 = formValues.Owner_Address1;
    this.icd.Owner_Address2 = formValues.Owner_Address2;
    this.icd.Owner_City = formValues.Owner_City;
    this.icd.Owner_Country = formValues.Owner_Country;
    this.icd.Owner_State = formValues.Owner_State;
    this.icd.Owner_Province = formValues.Owner_Province;
    this.icd.Owner_Postal_Code = formValues.Owner_Postal_Code;
    this.icd.Owner_Office_Phone = formValues.Owner_Mobile_Phone;
    this.icd.Owner_Home_Phone = formValues.Owner_Home_Phone;
    this.icd.Owner_Email = formValues.Owner_Email;
    this.icd.SSN_SIN = formValues.SSN_SIN;
    //this.icd.HUB_Manager_Contact_Name = formValues.HUB_Manager_Contact_Name;
    //this.icd.HUB_Manager_Contact_Number = formValues.HUB_Manager_Contact_Number;
    //this.icd.HUB_Manager_Contact_Email = formValues.HUB_Manager_Contact_Email;
    // Preserve the SF-loaded Hub ID — the form control is never populated from SF
    // so formValues.HUB_Manager_Contact is always empty, which would clear Hub__c in SF.
    this.icd.HUB_Manager_Contact = formValues.HUB_Manager_Contact || this.icd.HUB_Manager_Contact;
    this.icd.ICD_Using_HerbJoy_for_Insurance__c = formValues.isInsuranceRequired;
    if (this.icd.US_or_CA == "US") {
      this.icd.State_of_Incorporation = formValues.State_of_Incorporation;
      this.icd.Provinence_of_Incorporation = "";
    }
    else {
      this.icd.Provinence_of_Incorporation = formValues.Provinence_of_Incorporation;
      this.icd.State_of_Incorporation = "";
    }
    this.icd.Date_of_Incorporation = this.toSfDate(formValues.Date_of_Incorporation);
    //this.icd.PromotingOwner = formValues.Promoting_Owner;
    //this.icd.PromotingOwnerCompany = formValues.Promoting_Owner_Company;
    //this.icd.RegionalConsultant = formValues.Regional_Consultant;
    //this.icd.RegionalConsultantCompany = formValues.Regional_Consultant_Company;
    //this.icd.NationalConsultant = formValues.National_Consultant;
    //this.icd.NationalConsultantCompany = formValues.National_Consultant_Company;
    this.icd.LoadingDock = formValues.LoadingDock;
    this.icd.ForkLift = formValues.ForkLift;
    this.icd.StraightTruckRequired = formValues.StraightTruckRequired;
    this.icd.AppointmentRequired = formValues.AppointmentRequired;
    this.icd.LiftGateRequired = formValues.LiftGateRequired;
    this.icd.DeliveryContactName = formValues.DeliveryContactName;
    this.icd.AlternateContactName = formValues.AlternateContactName;
    this.icd.HoursofOperation = formValues.HoursofOperation;
    this.icd.BestDeliveryTime = formValues.BestDeliveryTime;
    this.icd.SpecialDeliveryRequirements = formValues.SpecialDeliveryRequirements;
    this.icd.CompanyWebsite = formValues.Company_Website;
    this.icd.Payroll_Provider__c = formValues.Payroll_Provider;
    this.icd.Payroll_Provider_other__c = formValues.Payroll_Provider_other;


    if (this.icd.US_or_CA == "US") {
      const campaignsString = this.US_Campaigns_selectedItems.join(', ');
      const retailsString = this.US_Retails_selectedItems.join(', ');
      this.icd.Campaigns = campaignsString;
      this.icd.Retailers = retailsString;

      const attachFields = [
        'Attach_US_Articles_of_Incorporation',
        'Attach_US_W_9',
        'Attach_US_Node_Form',
        'Attach_US_SS4_EIN',
        'Attach_US_Void_Check_Bank_Account',
        'Attach_US_Additional_Insurance',
        'Attach_US_Form_8821',
        'Attach_US_Homeowner_Insurance',
        'Attach_US_ADP_Payroll',
        'Attach_US_Certificate_of_Insurance',
        'Attach_US_Payroll_Setup'
        ,'Disability_Form'
      ];

      for (const field of attachFields) {
        const filteredBase64Array = this.fileData
          .filter(file => file.attachment_Type === field)
          .map(file => file.attachment_Base64);

        const commaSeparatedBase64 = filteredBase64Array.join('$$$');

        this.icd[field] = commaSeparatedBase64;
      }


    }
    else {
      
      const campaignsString = this.Canada_Campaigns_selectedItems.join(', ');
      const retailsString = this.Canada_Retails_selectedItems.join(', ');
      this.icd.Campaigns = campaignsString;
      this.icd.Retailers = retailsString;

      const attachCanadaFields = [
        'Attach_Canada_Articles_of_Incorporation',
        'Attach_Canada_CRA_Consent',
        'Attach_Canada_Bank_Statement_or_Direct_Deposit',
        'Attach_Canada_Worker_Compensation_Coverage',
        'Attach_Canada_Insurance_Application',
        'Attach_Canada_Additional_Insurance_Questionnaire',
        'Attach_Canada_Homeowner_Insurance',
        'Attach_Canada_ADP_Payroll',
        'Attach_Canada_Out_of_Province_Qualification',
        'Attach_Canada_Waddell_Privacy',
        'Attach_Canada_Certificate_of_Insurance'
        , 'Disability_Form'
      ];

      for (const field of attachCanadaFields) {
        const filteredBase64Array = this.fileData
          .filter(file => file.attachment_Type === field)
          .map(file => file.attachment_Base64);

        const commaSeparatedBase64 = filteredBase64Array.join('$$$');

        this.icd[field] = commaSeparatedBase64;
      }

      

    }

    this.icd.Male_Emp = formValues.Male_Emp;
    this.icd.FeMale_Emp = formValues.FeMale_Emp;
    this.icd.Disability_Form = formValues.Disability_Form;

    this.icd.Attachments = this.fileData.filter(f => f.status === 'uploaded');
    this.icd.TestCampaignNotListed = formValues.TestCampaignNotListed;
    this.icd.IsSubmitted = isSubmitted;
    if (formValues.isInsuranceRequired == "true") {
      this.icd.isInsuranceRequired = true;
    }
    else {
      this.icd.isInsuranceRequired = false;
    }
    
    //console.log(this.icd);
    this.SaveDatatoDB(isSubmitted);
    
  }

  Showsuccesspopup(str: string, isSubmitted: boolean) {

    if (isSubmitted) {
     
        Swal.fire({
          title: str,
          icon: 'success',
          confirmButtonText: 'Back to Distributors ',
          showDenyButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          denyButtonText: ' Open HJ portal',
          showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
          preConfirm: async (val) => {
            if (val) {

            }
          },
        }).then((result) => {

          if (result.isConfirmed) {
            let url = '/icdreport/';
            this.router.navigate([url]);
          } else if (result.isDenied) {
            let urls = environment.hjPortalUrl + "/ICD_ACK/ICD_details.aspx?q=" + this.id + "";
            // Open the URL in a new tab
            window.open(urls, '_blank');
            let url = '/icdreport/';
            this.router.navigate([url]);
          }
        });
      
     
    }
    else {


      Swal.fire({
        title: str,
        icon: 'success',
        confirmButtonText: 'Ok ',
        showDenyButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        denyButtonText: ' Open HJ portal',
        showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
        preConfirm: async (val) => {
          if (val) {

          }
        },
      }).then((result) => {

        
        if (result.isConfirmed) {
          let url = "/icddetail/offcamp/" + this.id + "/";
         
          this.router.navigate([url]);
        } 
      });
    }

  }
   

  SaveDatatoDB(isSubmitted: boolean) {

    Swal.fire({
      title: 'Submitting data...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    // Create a new instance of the ICD class
    let responseAPI = new ResponseAPI();
    this.sfDataService.CreateICDStep3(this.icd)
      .subscribe(
        data => {
          Swal.close();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {
            //location.reload();
            this.Showsuccesspopup('Data Saved Successfully', isSubmitted);
            //setTimeout(() => {
              this.alertService.showMessage('ICD', `Data Saved Successfully`, MessageSeverity.success);
              this.alertService.stopLoadingMessage();
            this.isLoading = false;
            if (!isSubmitted) {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
            
            //}, 200);
          }
          else {

            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.btnDisplay = true;

            // FR6: surface the real server message (e.g. document move/confirm failure) rather
            // than a generic error, and guard against a missing ErrorList payload.
            const serverMessage = responseAPI.description
              || (responseAPI.data && responseAPI.data.error && responseAPI.data.error.message)
              || 'An error occurred while saving data. Please try again.';
            const errorCode = (responseAPI.data && responseAPI.data.error && responseAPI.data.error.errorCode) || '';

            this.alertService.showMessage('ICD', 'Submission failed', MessageSeverity.error);
            this.alertService.showStickyMessage('Unable to store data', serverMessage, MessageSeverity.error, errorCode);

          }

        },
        error => {
          Swal.close();
          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

  }

  numberValidator(control: FormControl) {
    const isValid = /^\d+$/.test(control.value);
    return isValid ? null : { 'invalidNumber': true };
  }

  BindDropdowns() {
    //debugger;
    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');

    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getMasterConfigs("US_State,Canada_Province,US_Retails,US_Campaigns,Canada_Retails,Canada_Campaigns,DeliveryTime")
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
          this.masterConfig = data;
          this.ddlUSStates = this.masterConfig.filter(a => a.type == "US_State");
          this.ddlCAProvinence = this.masterConfig.filter(a => a.type == "Canada_Province");
          //this.Canada_campaignData = this.masterConfig.filter(a => a.type == "Canada_Campaigns");
       //   this.Canada_retailsData = this.masterConfig.filter(a => a.type == "Canada_Retails");
         // this.US_campaignData = this.masterConfig.filter(a => a.type == "US_Campaigns");
        //  this.US_retailsData = this.masterConfig.filter(a => a.type == "US_Retails");
          this.ddlBest_Delivery_Time = this.masterConfig.filter(a => a.type == "DeliveryTime");
          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

    this.sfDataService.getCMReports().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      this.Canada_campaignData = res.filter(a => a.country == "CAN" && a.status != "Ended" && a.dueDiligenceRequired != "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));;      
      this.US_campaignData = res.filter(a => a.country == "USA" && a.status != "Ended" && a.dueDiligenceRequired != "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));


      this.Canada_campaignData_DD = res.filter(a => a.country == "CAN" && a.status != "Ended" && a.dueDiligenceRequired == "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));;
      this.US_campaignData_DD = res.filter(a => a.country == "USA" && a.status != "Ended" && a.dueDiligenceRequired == "Yes")
        .sort((a, b) => a.campaignName.localeCompare(b.campaignName));

    });


    this.sfDataService.getRetails().subscribe(resp => {
      ////console.log(resp);

      let res: any;

      res = resp;

      var testretail = {
        endDate  :          null,
id : "a163s00000MRT5YAAX123",
isDeleted:"false",
name :"N/A",
ownerId:"0051I000002BtCTQA0123",
startDate:"2010-01-01"
}

      this.Canada_retailsData = res.filter(a => a.isDeleted == "false");
      this.US_retailsData = res.filter(a => a.isDeleted == "false");

      this.US_retailsData.push(testretail);
      this.Canada_retailsData.push(testretail);
      ////console.log(this.US_retailsData)

      ////console.log(this.Canada_campaignData)
    });

    this.sfDataService.getAddInfoDDs().subscribe(resp => {
      //console.log(resp);

      let res: any;

      res = resp;

      this.NC_namesData = res.ncNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));
;
      this.RC_namesData = res.rcNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      this.PO_namesData = res.poNames.filter(item => !item.name.startsWith('test') && !item.name.startsWith('smart circle'));;
      //$('.select2').select();
      ////console.log(this.NC_namesData)

      ////console.log(this.Canada_campaignData)
    });

  }

  private mapDataToICD(data: any) {

    if (data == null) {
      
      this.icdForm.disable();
      this.alertService.showMessage('ICD', `This Case is not assigned to view`, MessageSeverity.error);
      this.alertService.startLoadingMessage('', 'This Case is not assigned to view');
      this.alertService.showStickyMessage('ICD', 'This Case is not assigned to view', MessageSeverity.error, "");
      this.btnDisplay = false;
      this.isCheckboxesDisabled = true;
      return;
    }
    this.isdataavailable = true;
    //debugger;
    //console.log(data);
    this.icdForm.controls['US_or_CA'].setValue(data.uS_or_CA);
    this.onCountryChange();
    this.icdForm.controls['Full_Legal_Company_Name'].setValue(data.full_Legal_Company_Name);
    this.icdForm.controls['Tax_ID'].setValue(data.tax_ID);
    this.icdForm.controls['State_of_Incorporation'].setValue(data.state_of_Incorporation);
    this.icdForm.controls['Date_of_Incorporation'].setValue(this.toDisplayDate(data.date_of_Incorporation));
    this.icdForm.controls['Provinence_of_Incorporation'].setValue(data.provinence_of_Incorporation);
    
    this.icdForm.controls['HUB_Manager_Contact_Email'].setValue(data.huB_Manager_Contact_Email);
    

    this.icdForm.controls['Company_Address1'].setValue(data.homeAddress);
    this.icdForm.controls['Company_Address2'].setValue(data.homeAddress2);
    this.icdForm.controls['Company_City'].setValue(data.homeCity);
    this.icdForm.controls['Company_Postal_Code'].setValue(data.homeZipCode);
    this.icdForm.controls['Company_Office_Phone'].setValue(data.homePhone);
    this.icdForm.controls['Company_Business_Email'].setValue(data.company_Business_Email);
    this.icdForm.controls['Company_Country'].setValue(data.homeCountry);
    this.icdForm.controls['Company_State'].setValue(data.homeState);
    this.icdForm.controls['Company_Province'].setValue(data.homeState);

    this.icdForm.controls['Owner_First_Name'].setValue(data.owner_First_Name);
    this.icdForm.controls['Owner_Last_Name'].setValue(data.owner_Last_Name);
    this.secondaryOwner = data.secondary_Owner || ''; // Feature 10

    this.icdForm.controls['Owner_Middle_Name'].setValue(data.owner_Middle_Name);

    // Restore the "No Middle Name" toggle state from the loaded record.
    if (data.owner_Middle_Name != null && data.owner_Middle_Name !== '') {
      this.noMiddleName = false;
      this.icdForm.get('Owner_Middle_Name')?.enable();
      this.icdForm.get('Owner_Middle_Name').setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]);
    } else {
      this.noMiddleName = true;
      this.icdForm.get('Owner_Middle_Name').clearValidators();
      this.icdForm.get('Owner_Middle_Name')?.disable();
    }
    this.icdForm.get('Owner_Middle_Name').updateValueAndValidity();

    const rawSsn = (data.ssN_SIN || '').replace(/\D/g, '').slice(0, 9);
    this.icdForm.controls['SSN_SIN'].setValue(rawSsn);
    this.displayValue = this.maskSSN(rawSsn);

    this.icdForm.controls['Owner_Preferred_First_Name'].setValue(data.owner_Preferred_First_Name);
    this.icdForm.controls['Owner_Preferred_Last_Name'].setValue(data.owner_Preferred_Last_Name);

    if (data.isReopenCase == "yes") {
      this.isReopenCase = true;
    }
    
    if (data.preferred_Name_Different_from_Legal_Name__c == "true") {
      this.icdForm.controls['Is_Preferred_Differ'].setValue('Yes');
      this.onIsPreferChange('Yes');
    }
    else {
      this.icdForm.controls['Is_Preferred_Differ'].setValue('No');
      this.onIsPreferChange('No');
    }
    this.icdForm.controls['Owner_Perc'].setValue(data.ownership);
    this.icdForm.controls['Owner_Address1'].setValue(data.owner_Address1);
    this.icdForm.controls['Owner_Address2'].setValue(data.owner_Address2);
    this.icdForm.controls['Owner_City'].setValue(data.owner_City);
    this.icdForm.controls['Owner_Country'].setValue(data.owner_Country);
    this.icdForm.controls['Owner_State'].setValue(data.owner_State);
    this.icdForm.controls['Owner_Province'].setValue(data.owner_State);
    this.icdForm.controls['Owner_Postal_Code'].setValue(data.owner_Postal_Code);
    this.icdForm.controls['Owner_Mobile_Phone'].setValue(data.owner_Office_Phone);
    this.icdForm.controls['Owner_Home_Phone'].setValue(data.owner_Home_Phone);
    this.icdForm.controls['Owner_Email'].setValue(data.owner_Email);

    this.icdForm.controls['HUB_Manager_Contact_Name'].setValue(data.huB_Manager_Contact_Name);
    this.icdForm.controls['HUB_Manager_Contact_Number'].setValue(data.huB_Manager_Contact_Number);

    this.icdForm.controls['Promoting_Owner'].setValue(data.promotingOwner);
    this.icdForm.controls['Promoting_Owner_Company'].setValue(data.promotingOwnerCompany);
    this.icdForm.controls['Regional_Consultant'].setValue(data.regionalConsultant);
    this.icdForm.controls['Regional_Consultant_Company'].setValue(data.regionalConsultantCompany);
    this.icdForm.controls['National_Consultant'].setValue(data.nationalConsultant);
    this.icdForm.controls['National_Consultant_Company'].setValue(data.nationalConsultantCompany);
    this.icdForm.controls['Company_Website'].setValue(data.companyWebsite);
    
    this.icdForm.controls['Payroll_Provider'].setValue(data.payroll_Provider__c);
    if (data.payroll_Provider__c === 'Other (Not Listed)') {
      this.isPayrollProviderOther = true;
      this.icdForm.get('Payroll_Provider_other').setValidators([Validators.required, this.noHtmlTagsValidator.bind(this)]);
    }
    this.icdForm.controls['Payroll_Provider_other'].setValue(data.payroll_Provider_other__c);
    this.icdForm.get('Payroll_Provider_other').updateValueAndValidity();

    
    ////console.log(data);
    
    this.icdForm.controls['TestCampaignNotListed'].setValue(data.testCampaignNotListed);
    this.US_savedCampaignsString = data.campaigns

    if (data.uS_or_CA == 'US') {
      if (data.campaigns != null) {
        this.US_Campaigns_selectedItems = data.campaigns.split(',').map((item) => item.trim());

      }
      if (data.retailers != null) {
        this.US_Retails_selectedItems = data.retailers.split(',').map((item) => item.trim());

      }
      
      

    }
    else {
      if (data.campaigns != null) {
        this.Canada_Campaigns_selectedItems = data.campaigns.split(',').map((item) => item.trim());

      }
      if (data.retailers != null) {
        this.Canada_Retails_selectedItems = data.retailers.split(',').map((item) => item.trim());

      }
      
      
    }
    

    

    this.icd.AccountID = data.accountID;

    this.icd.Owner_First_Name = data.owner_First_Name;
    this.icd.Owner_Last_Name = data.owner_Last_Name;

    this.icd.Owner_Preferred_First_Name = data.owner_Preferred_First_Name;
    this.icd.Owner_Preferred_Last_Name = data.owner_Preferred_Last_Name;
    this.icd.Owner_Name = data.owner_Name;
    this.icd.HUB_Manager_Contact = data.huB_Manager_Contact;
    this.icd.HUB_Manager_Contact_Name = data.huB_Manager_Contact_Name;
    this.icd.HUB_Manager_Contact_Number = data.huB_Manager_Contact_Number;
    this.icd.HUB_Manager_Contact_Email = data.huB_Manager_Contact_Email;
    this.icd.HUB_Assistance_Email = data.huB_Assistance_Email;
    this.icd.PromotingOwner = data.promotingOwner;
    this.icd.PromotingOwnerCompany = data.promotingOwnerCompany;
    this.icd.RegionalConsultant = data.regionalConsultant;
    this.icd.RegionalConsultantCompany = data.regionalConsultantCompany;
    this.icd.NationalConsultant = data.nationalConsultant;
    this.icd.NationalConsultantCompany = data.nationalConsultantCompany;
    this.icd.CaseID = data.caseID;
    this.icd.ContactID = data.contactID;
    if (data.attachments != null) {
      for (let i = 0; i < data.attachments.length; i++) {
        const file = data.attachments[i];

        this.fileData.push({ attachment_FileName: file.attachment_FileName, attachment_Base64: file.attachment_Base64, attachment_Type: file.attachment_Type });
        // File already exists in DB — clear required error so the control is treated as valid
        const ctrl = this.icdForm.get(file.attachment_Type);
        if (ctrl) { ctrl.setErrors(null); }
      }

    }
    
    if (data.onboarding_Step_3A_Complete__c == "true" ) {
      this.icd.HubInfoReceivedOn = data.hubInfoReceivedOn;
      this.icdForm.disable();
      this.alertService.showMessage('ICD', `Step 3 Already Completed`, MessageSeverity.success);
      this.alertService.startLoadingMessage('', 'Step 3 Already Completed');
      this.alertService.showStickyMessage('ICD', 'Step 3 Already Completed', MessageSeverity.error, "");
      this.btnDisplay = false;
      this.isCheckboxesDisabled = true;
    }
    this.dataEmitter.emit(this.datad);


  }


  toggleMiddleName(event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const middleName = this.icdForm.get('Owner_Middle_Name');
    if (isChecked) {
      // "No Middle Name" — waive the field: clear value/validators and disable.
      this.noMiddleName = true;
      middleName.setValue('');
      middleName.clearValidators();
      middleName?.disable();
    } else {
      // Middle name required again — re-enable and restore the full validator set.
      this.noMiddleName = false;
      middleName?.enable();
      middleName.setValidators([Validators.required, Validators.maxLength(this.fieldMaxLengths.Owner_Middle_Name), this.noHtmlTagsValidator.bind(this)]);
    }
    middleName.updateValueAndValidity();
  }

  onIsPreferChange(Is_Preferred_Differ) {

    if (Is_Preferred_Differ === 'Yes') {
      this.IsPref_Differ = true;
      this.icdForm.get('Owner_Preferred_First_Name').setValidators([Validators.required]);
      this.icdForm.get('Owner_Preferred_Last_Name').setValidators([Validators.required]);

    } else {
      this.IsPref_Differ = false;
      this.icdForm.get('Owner_Preferred_First_Name').clearValidators();
      this.icdForm.get('Owner_Preferred_Last_Name').clearValidators();
    }
    this.icdForm.get('Owner_Preferred_First_Name').updateValueAndValidity();
    this.icdForm.get('Owner_Preferred_Last_Name').updateValueAndValidity();

  }

  BindData(id: string) {
    //debugger;

    this.isLoading = true;
    this.alertService.startLoadingMessage('', 'Data loading...');
    //this.icd.Owner_Email = this.icdForm.value["Owner_email"];
    this.sfDataService.getICDStep3(id)
      .subscribe(
        data => {
          ////console.log(data);
          //debugger;
         
          this.mapDataToICD(data);
          ////console.log(data);


          this.alertService.stopLoadingMessage();
        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            this.offerAlternateHost();
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to get data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to get data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
  }

  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }

  offerAlternateHost() {

    if (Utilities.checkIsLocalHost(location.origin) && Utilities.checkIsLocalHost(this.configurations.baseUrl)) {
      this.alertService.showDialog('Dear Developer!\nIt appears your backend Web API service is not running...\n' +
        'Would you want to temporarily switch to the online Demo API below?(Or specify another)',
        DialogType.prompt,
        (value: string) => {
          this.configurations.baseUrl = value;
          this.alertService.showStickyMessage('API Changed!', 'The target Web API has been changed to: ' + value, MessageSeverity.warn);
        },
        null,
        null,
        null,
        this.configurations.fallbackBaseUrl);
    }
  }

  trimFormValues() {

    // Avoid setting value on file input controls (browsers only allow
    // programmatically setting input[type=file].value to an empty string).
    // Skip any control that appears to be a file control (name starts with "Attach_")
    // or whose current value is not a string.
    Object.keys(this.icdForm.controls).forEach(key => {
      // Skip known file-type controls
      if (/^Attach_/i.test(key) || /Attach/i.test(key)) {
        return;
      }

      const control = this.icdForm.get(key);

      if (!control) {
        return;
      }

      const val = control.value;

      // Skip File / FileList / object values to avoid InvalidStateError
      if (val instanceof File || (typeof FileList !== 'undefined' && val instanceof FileList) || typeof val === 'object') {
        return;
      }

      if (typeof val === 'string') {
        try {
          control.setValue(val.trim());
        } catch (e) {
          // Don't let an error on one control break the whole form processing
          console.warn(`trimFormValues: skipped trimming control '${key}' due to error`, e);
        }
      }
    });
  }

  noHtmlTagsValidator(control: any) {

    if (!control.value) {
      return null;
    }

    const value = control.value.toString().trim();

    const htmlPattern =
      /(<[^>]+>|&lt;|&gt;|javascript:|onerror=|onload=|<script|<\/script>)/gi;

    if (htmlPattern.test(value)) {
      return { invalidHtml: true };
    }

    return null;
  }

  getCharacterCount(controlName: string): number {
    return (this.icdForm.get(controlName)?.value || '').length;
  }

  getMaxLength(controlName: string): number {
    return this.fieldMaxLengths[controlName] || 0;
  }

  reset() {
    this.formResetToggle = false;

    setTimeout(() => {
      this.formResetToggle = true;
    });
  }
}

